// Module
var code = `<div class="panels-container">
    <div class="panels-container-tabs{{isCollapsed ? ' _collapsed' : ''}}{{isVisibleTabs ? '' : ' _without-tabs'}}">
        {{#each tabItems: i}}
            {{#if tabItems[i].isVisible}}
                {{#if tabItems[i] === selectedTabItem}}
                    <div class="panels-container-tabs-tab _active{{isVisibleTabs ? '' : ' _hidden'}}" on-click="['onTabItemClick', tabItems[i]]">
                        {{tabItems[i].text}}
                    </div>
                    {{else}}
                    <div class="panels-container-tabs-tab{{isVisibleTabs ? '' : ' _hidden'}}" on-click="['onTabItemClick', tabItems[i]]">
                        {{tabItems[i].text}}
                    </div>
                {{/if}}
            {{/if}}
        {{/each}}
        {{#if isShowCollapseButton}}
            <div class="panels-container-tabs-collapse-button" as-tooltip="infoBtnTooltip" on-click="onCollapseButtonClick">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{isCollapsed ? 'ArrowUp' : 'ArrowDown'}}"></use>
                </svg>
            </div>
        {{/if}}
    </div>
    <div class="panels-container-panel{{isCollapsed ? ' _collapsed' : ''}}{{isVisibleTabs ? '' : ' _without-tabs'}}">
        {{yield}}
    </div>
</div>`;
// Exports
export default code;